import { Link } from "react-router-dom";
import { useWallet } from "@/context/WalletContext";
import { useLang } from "@/context/LanguageContext";
import { Send, MessageCircle, Instagram, Facebook, Music2, Twitter, Mail } from "lucide-react";

const SOCIALS = [
  { key: "x", label: "X", icon: Twitter },
  { key: "telegram", label: "Telegram", icon: Send },
  { key: "discord", label: "Discord", icon: MessageCircle },
  { key: "instagram", label: "Instagram", icon: Instagram },
  { key: "tiktok", label: "TikTok", icon: Music2 },
  { key: "facebook", label: "Facebook", icon: Facebook },
];

export function Footer() {
  const { settings } = useWallet();
  const { t } = useLang();
  const social = settings?.social || {};
  const active = SOCIALS.filter((s) => social[s.key]);

  return (
    <footer className="relative z-10 border-t border-cosmic/10 mt-24">
      <div className="max-w-[1500px] mx-auto px-6 md:px-8 py-14 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <img src="/textures/logo.png" alt="logo" className="h-10 w-10 object-contain" />
            <div className="font-display text-lg tracking-[0.2em]">THE PORTAL UNIVERSE</div>
          </div>
          <p className="mt-5 text-cosmic/60 text-sm max-w-sm leading-relaxed font-light">{t.footer.blurb}</p>

          <div className="mt-7">
            <div className="text-overline mb-3">{t.footer.follow}</div>
            <div className="flex flex-wrap gap-3" data-testid="footer-socials">
              {active.length ? active.map((s) => {
                const Icon = s.icon;
                return (
                  <a key={s.key} href={social[s.key]} target="_blank" rel="noreferrer"
                    data-testid={`social-${s.key}`} title={s.label}
                    className="w-10 h-10 flex items-center justify-center border border-cosmic/20 text-cosmic hover:text-portal hover:border-portal/50 transition-colors">
                    <Icon size={16} />
                  </a>
                );
              }) : (
                <div className="flex gap-3 opacity-30">
                  {SOCIALS.map((s) => { const Icon = s.icon; return (
                    <span key={s.key} className="w-10 h-10 flex items-center justify-center border border-cosmic/20 text-cosmic"><Icon size={16} /></span>
                  ); })}
                </div>
              )}
            </div>
            <a href="mailto:theportalmars@gmail.com" data-testid="footer-email"
              className="inline-flex items-center gap-2 mt-4 text-sm text-cosmic/70 hover:text-portal transition-colors font-mono">
              <Mail size={15} /> theportalmars@gmail.com
            </a>
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="text-overline mb-4">{t.footer.navigate}</div>
          <ul className="space-y-3 text-sm text-cosmic/70">
            <li><Link to="/explore" className="hover:text-portal">{t.nav.explore}</Link></li>
            <li><Link to="/marketplace" className="hover:text-portal">{t.nav.marketplace}</Link></li>
            <li><Link to="/hall" className="hover:text-portal">{t.nav.hall}</Link></li>
            <li><Link to="/lore" className="hover:text-portal">{t.nav.lore}</Link></li>
          </ul>
        </div>
        <div className="md:col-span-4">
          <div className="text-overline mb-4">{t.footer.protocol}</div>
          <ul className="space-y-3 text-sm text-cosmic/70 font-mono">
            <li>{t.footer.network} · Polygon</li>
            <li>{t.footer.standard} · ERC-721</li>
            <li>{t.footer.settlement} · USDC</li>
            <li>{t.footer.total} · 724,000</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-cosmic/10 py-6 text-center text-xs text-cosmic/40 font-mono tracking-widest">
        © {new Date().getFullYear()} THE PORTAL UNIVERSE — {t.footer.rights}
      </div>
    </footer>
  );
}
